import { Box, Tab } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import React, { useState } from 'react'
import Profile from '../Home/Profile';
import About from '../AboutMe/About'
import Portfolio from '../Projects/Portfolio';
import Contact from '../ContactMe/Contact'


// import FavoriteIcon from '@mui/icons-material/Favorite'

export default function MuiTabs() {
    const [value, setValue] = useState('1')
    const handleChange = (event, newValue) => {
        setValue(newValue)

        window.scrollTo(0,0);
    }

    const handleClick = (value) => {
        setValue(value)
        window.scrollTo(0,0);
    }
    
    return (
        <Box>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 2, borderColor:'divider'}}>
                    <TabList 
                        aria-label='Tabs example' 
                        onChange={handleChange}
                        centered
                        TabIndicatorProps={{sx: {backgroundColor: '#00FFCA', height: 2}}}
                        sx={{
                            "& button": { color: 'aliceblue' },
                            "& button.Mui-selected": { borderRadius: '10px',color: "#00FFCA", borderColor: "aliceblue"},
                            '& .MuiTabs-flexContainer': { flexWrap: 'wrap',},

                        }}
                        >
                        <Tab label='Home' value='1'/>
                        <Tab label='About' value='2' />
                        <Tab label='Projects' value='3' />
                        <Tab label='Contact' value='4' />
                    </TabList>
                  
                </Box>

                <TabPanel value='1'>
                    <Profile onClick={handleClick}/>
                </TabPanel>
                <TabPanel value='2'>
                    <About />
                </TabPanel>
                <TabPanel value='3'>
                    <Portfolio onClick={handleClick}/>
                </TabPanel>
                <TabPanel value='4'>
                    <Contact />
                </TabPanel>
                
            </TabContext>
        </Box>
    )
}